import { render } from "./Creacion.vue?vue&type=template&id=9cfc949a"
import script from "./Creacion.vue?vue&type=script&lang=js"
export * from "./Creacion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__